import z from "zod";

import { AccountSchema, OrgSchema, UserSchema } from "../models/generated";

export enum AuthProvider {
  ZALO = "ZALO",
  FIREBASE = "FIREBASE"
}
export const AuthProviderEnumSchema = z.nativeEnum(AuthProvider);

export const ZaloLoginSchema = z.object({ accessToken: z.string().min(1) });
export type ZaloLogin = z.infer<typeof ZaloLoginSchema>;

export const RefreshSchema = z.object({ refreshToken: z.string().min(1) });
export type Refresh = z.infer<typeof RefreshSchema>;

export const AccountDetailSchema = AccountSchema.extend({
  user: UserSchema.nullable(),
  org: OrgSchema.nullable()
});
export type AccountDetail = z.infer<typeof AccountDetailSchema>;

export const EmailLinkRequestSchema = ZaloLoginSchema.extend({
  email: z.string().email()
});
export type EmailLinkRequest = z.infer<typeof EmailLinkRequestSchema>;

export const LinkFirebaseSchema = z.object({
  linkToken: z.string().min(1),
  firebaseToken: z.string().min(1)
});
export type LinkFirebaseRequest = z.infer<typeof LinkFirebaseSchema>;

export const LinkZaloSchema = z.object({
  zaloAccessToken: z.string().min(1)
});
export type LinkZaloRequest = z.infer<typeof LinkZaloSchema>;

export const ZaloWebCallbackSchema = z.object({
  code: z.string().min(1),
  state: z.string().min(1)
});
export type ZaloWebCallback = z.infer<typeof ZaloWebCallbackSchema>;

export const LinkGoogleSchema = z.object({
  firebaseToken: z.string().min(1)
});
export type LinkGoogleRequest = z.infer<typeof LinkGoogleSchema>;

export const LinkSessionInfoSchema = z.object({
  from: z.object({
    provider: AuthProviderEnumSchema,
    visibleId: z.string(),
    avatar: z.string().nullish(),
    name: z.string().nullish()
  }),
  to: z.object({
    provider: AuthProviderEnumSchema,
    visibleId: z.string(),
    avatar: z.string().nullish(),
    name: z.string().nullish()
  }),
  expiredAt: z.number().int().positive()
});
export type LinkSessionInfo = z.infer<typeof LinkSessionInfoSchema>;

export const LinkStatusSchema = z.object({
  linked: z.boolean(),
  pendingSession: z.object({ email: z.string() }).nullable()
});
export type LinkStatus = z.infer<typeof LinkStatusSchema>;

export const TokenPairSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string()
});
export type TokenPair = z.infer<typeof TokenPairSchema>;

export const LinkResultSchema = z.union([
  z.object({ linked: z.literal(true) }),
  z.object({ conflict: z.literal(true), supportEmail: z.string() })
]);
export type LinkResult = z.infer<typeof LinkResultSchema>;

export const LinkFirebaseResultSchema = z.object({
  linked: z.boolean(),
  reason: z.string().optional()
});
export type LinkFirebaseResult = z.infer<typeof LinkFirebaseResultSchema>;
